<template>
  <!-- due to a misconception in appLayout an extra outer div is required here -->
  <div>
    <div :class="{ 'pb-12 inherit-height flex scroll-container': true, 'mt-3': !xs, 'mx-3': !xs, 'mx-auto': xl }" style="max-width: 1880px">
      <template v-for="(galleries, i) in galleriesAndTitlesByGroup">
        <div v-if="galleries.group && galleries.group.name" class="d-flex text-h4 justify-center pb-2" :key="i">
          {{ galleries.group.name }}
        </div>
        <v-row class="justify-center" style="margin-bottom: 32px" :no-gutters="xs" :key="i + '_r'">
          <v-col cols="12" sm="6" md="6" lg="4" xl="3" v-for="(gallery, i) in galleries.galleries" :key="i">
            <gallery-teaser :gallery="gallery"></gallery-teaser>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
import GalleryTeaser from './GalleryTeaser';

export default {
  name: 'GalleriesOverview',
  mixins: [common],
  components: {
    GalleryTeaser,
  },
  computed: {
    ...mapState('gallery', ['galleries', 'groups']),
    galleriesAndTitlesByGroup() {
      const instance = Number(this.$route.params.instance);
      let emptyTextForUngrouped = [{}];
      let filteredGroups = emptyTextForUngrouped.concat(this.groups.filter((g) => g.instance === instance).sort((a, b) => Number(a.sort) - Number(b.sort)));

      let filledGroups = filteredGroups
        .map((g) => {
          let groupId = g.id;
          let galleriesByGroup = this.galleries
            .filter((group) => {
              let noGroup = !group.groupIdFk && !groupId;
              return group.instance === instance && (noGroup || groupId === group.groupIdFk);
            })
            .sort((a, b) => Number(a.sort) - Number(b.sort));

          return { group: g, galleries: galleriesByGroup };
        })
        .filter((o) => o.galleries.length > 0);
      return filledGroups;
    },
  },
};
</script>
